import { generateTestId } from "@client-shared";

export const setOrderDetailShippingButtonsTestId = (identifier: string): string => generateTestId("OrderDetailShippingButtons", identifier);
